import { logger, loginNewWrapper } from '@cap/rzmt-core';
import { isBoolean } from 'lodash-es';
import { CLIENT_TYPE, getClientTypeSync } from '@cap/utils';
import { heartbeat } from '@cap/share/src/apis/courseDetail';
import { getLxCUUID } from './lxCuuid';
import { ICollege, ICourseDetail } from './type';
import { ENU_COURSE_AD_SWITCH } from './const';
import { RootState } from '@/store';

let uuid: null | string = null; // 唯一id

export function destroy() {
  uuid = null;
}
const startTime = Date.now(); // 开始学习时间,因为每个页面都是通过打开新网页进来的,所以当全局变量也可以
function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const getBAccountInfo = async () => {
  const FROM = getClientTypeSync(navigator.userAgent) || CLIENT_TYPE.unknown;
  let userInfo;
  let bizUserInfo;
  let bAccountInfo;

  try {
    userInfo = await loginNewWrapper.getUserInfo();
    bizUserInfo = await loginNewWrapper.getBizUserInfo();
    bAccountInfo = {
      mtUserId: userInfo?.userId || '',
      bAccountId: bizUserInfo?.userId,
      bAccountType: bizUserInfo?.userId && 1,
      bAccountLoginName: bizUserInfo?.userLogin,
      app: FROM,
    };
    return bAccountInfo;
  } catch (e) {
    logger.error(`getBAccountInfo error, ${e}`);
    return {
      app: FROM,
    };
  }
};

export const getCollegeByTenant = (collegegs: ICollege[] | null, tenant: string) => {
  if (!collegegs?.length || !tenant) return null;
  return collegegs.find((item) => item.shortUrl === tenant);
};

/**
 * 必须登录后才能学习的校验
 * @param {*} courseDetail // 课程详情
 */
let cacheIsLogin;
export const checkNeedLogin = async (courseDetail: ICourseDetail) => {
  const { restrictionSwitch, courseAbSwitch, fixedPrice, needLogin } = courseDetail;

  if (!needLogin) {
    return false;
  }

  // 已经登录过，开启了报名表，开启了黑白名单，付费课程，按又有逻辑处理
  const haveToBuy = fixedPrice > 0;
  if (!isBoolean(cacheIsLogin)) {
    cacheIsLogin = await loginNewWrapper.isLogin();
  }

  if (
    cacheIsLogin ||
    !!restrictionSwitch ||
    [ENU_COURSE_AD_SWITCH.WHITE_LIST, ENU_COURSE_AD_SWITCH.BLANK_LIST].indexOf(courseAbSwitch) > -1 ||
    !!haveToBuy
  ) {
    return false;
  }

  return true;
};

/**
 * 判断用户是否需要报名后才能学习本课程
 * @param {object} courseDetail // 课程详情
 */
export const checkNeedRegistration = async (courseDetail: ICourseDetail) => {
  const { restrictionSwitch, hadRegistration } = courseDetail;

  // 判断课程是否关联报名表单
  if (restrictionSwitch) {
    // 如果用户没有登录，跳转登录页面
    if (!isBoolean(cacheIsLogin)) {
      cacheIsLogin = await loginNewWrapper.isLogin();
    }

    if (cacheIsLogin) {
      // 如果用户没有报名，跳转报名页
      if (!hadRegistration) {
        return true;
      }
    } else {
      return true;
    }
  }

  return false;
};

export function getLearnProgressKey(data: any = {}) {
  return `mtdx_learn_progress:${data.courseId}${data.chapterId ? `:${data.chapterId}` : ''}`;
}

/**
 * 从 localStorage 中获取学习进度
 */
export function getLearnProgressFromLS(key) {
  const defaultValue = {
    nowProgress: 0,
    maxProgress: 0,
  };
  try {
    const cache = localStorage.getItem(key);
    if (cache) {
      const data = JSON.parse(cache);
      return data || defaultValue;
    }
  } catch (error) {
    logger.log(error);
  }
  return defaultValue;
}

/**
 * 把学习进度保存到 localStorage 中
 */
export function setLearnProgressToLS(key, progress) {
  try {
    localStorage.setItem(key, JSON.stringify(progress));
  } catch (error) {
    logger.log(error);
  }
}

export async function reportData(data, config, user) {
  if (!uuid) {
    uuid = uuidv4();
  }
  data = {
    ...data,
    uuid,
    startTime,
    unionId: getLxCUUID(), // 统一从灵犀的uuid中获取
  };
  try {
    // 获取到用户信息则上报userId

    if (user) {
      data.userId = user.userId;
    }

    await heartbeat(data, config);

    const learnProgressKey = getLearnProgressKey(data);
    const { nowProgress = 0, maxProgress = 0 } = data;
    setLearnProgressToLS(learnProgressKey, {
      nowProgress,
      maxProgress: nowProgress > maxProgress ? nowProgress : maxProgress, // 主要考虑未登录的情况下取不到 maxProgress
    });
  } catch (e) {
    console.log('🚀 ~ reportData ~ e:', e);
  }
}

export const getTenantInfo = (tenant: string, getState: Function) => {
  const state = getState() as RootState;
  const college = state.detailCourseData.base.collegeDetail;
  return {
    tenantId: college?.id,
    tenant: college?.shortUrl || tenant,
  };
};
